import type { CardPackInfo } from './card-packs.js';

const RANKS = ['jack', 'queen', 'king', 'ace'] as const;
const SUITS = ['hearts', 'diamonds', 'spades', 'clubs'] as const;
/** The first-party packs ship every Jack, Queen, King and Ace per suit, and a red and a black Joker (see scripts/packs/definitions.ts). */
const BUNDLED_FILES: readonly string[] = [...RANKS.flatMap((r) => SUITS.map((s) => `${r}-${s}.webp`)), 'joker-red.webp', 'joker-black.webp'];

/** A pack that ships inside the app: its eighteen images are in `public/packs/<id>/`. */
export function bundledPack(p: Omit<CardPackInfo, 'files' | 'base' | 'query'>): CardPackInfo {
  return { ...p, files: BUNDLED_FILES, base: `/packs/${p.id}` };
}
